import React from 'react';
import { X } from 'lucide-react';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section className="w-full bg-[#061A21] font-heading" aria-labelledby="painpoints-title" data-id="element-39" data-mp="2lm0urc5l7auk">
      <div className="mx-auto max-w-[820px] px-6 py-20 lg:py-28" data-id="element-40" data-mp="26xmt34jwpsfl">
        <h2 id="painpoints-title" className="text-center text-2xl font-bold leading-tight tracking-[-0.02em] text-white sm:text-3xl lg:text-[2.5rem]" data-id="element-41" data-mp="2bx93754fusk6">
          Si sos profe de Stretching en Argentina,{' '}
          <span className="text-[#FF6B6B]" data-id="element-42" data-mp="2204gn46okv2u">esto te va a sonar familiar:</span>
        </h2>

        <ul className="mt-12 flex flex-col gap-4" data-id="element-43" data-mp="1o0lj15bhx24s">
          {painPoints.map(point => <li key={point} className="flex items-start gap-4 rounded-2xl border border-[#2DD4C8]/20 bg-[#0A2731] px-5 py-5 transition-colors hover:border-[#2DD4C8]/35 hover:bg-[#0C2F3A] sm:px-7 sm:py-6" data-id="element-44" data-mp="1szpuy3pt1dyt">
              <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#FF6B6B]/45 bg-[#FF6B6B]/10" data-id="element-45" data-mp="3nabmw91u3y8k">
                <X className="h-3.5 w-3.5 text-[#FF6B6B]" data-id="element-46" data-mp="27sz226d61uwh" />
              </span>
              <p className="text-[15px] leading-relaxed text-white/85 sm:text-base" data-id="element-47" data-mp="27v338gjokft2">{point}</p>
            </li>)}
        </ul>

        <p className="mt-20 text-center text-2xl font-bold leading-tight tracking-[-0.02em] text-white sm:text-3xl lg:text-[2.5rem] lg:mt-28" data-id="element-48" data-mp="1g1astspopohv">
          ¿Cuántas clases más vas a{' '}
          <span className="text-[#2DD4C8] underline decoration-[#2DD4C8] decoration-2 underline-offset-[6px]" data-id="element-49" data-mp="1p2hai542l5cp">
            improvisar?
          </span>
        </p>
      </div>
    </section>;
}